import React from 'react';
import Card from '../components/Card';
import './Pages.css';

const blogPosts = [
  {
    id: 1,
    title: 'BAM Blockchain',
    description: 'Successfully completed the BAM Blockchain workshop in our community.',
    imageUrl: '/assest/img/BAM.png',
    date: 'Jan 18, 2025'
  },
  {
    id: 2,
    title: 'Ulead Project',
    description: 'successfully completed the Ulead project in our community.',
    imageUrl: '/assest/img/ulead.png',
    date: 'Dec 18, 2024'
  },
  {
    id: 3,
    title: 'Tech Meetup',
    description: 'Monthly tech meetup featuring discussions on emerging technologies and their impact on local innovation.',
    imageUrl: '/assest/img/ref.png',
    date: 'Dec 05, 2024'
  },
  {
    id: 4,
    title: 'Buni Divas',
    description: 'We teach 3D printing technology and demonstrate how girls can leverage this technology to solve societal problems.',
    imageUrl: '/assest/img/divas.png',
    date: 'Nov 25, 2024'
  }
];

function News() {
  return (
    <>
      <section className="news-hero">
        <div className="news-hero-background">
          <img src="/assest/img/jamiitalk.jpg" alt="News background" />
        </div>
        <div className="news-hero-overlay">
          <div className="news-hero-container">
            <h1 className="news-hero-title">News</h1>
            <p className="news-hero-subtitle">Stay informed about innovation and technology at Buni Hub</p>
            <a href="#news-list" className="news-hero-button">View News →</a>
          </div>
        </div>
      </section>

      <main id="news-list">
        <Card items={blogPosts} eyebrow="NEWS & UPDATES" title="Latest at BuniHub" autoScroll />
      </main>
    </>
  );
}

export default News;
